import React from 'react'
import CmsPageScreen from '../Component/CmsPageScreen'

function Contact() {
  return <CmsPageScreen pageId={2} />
}

export default Contact
